import { useEffect } from "react";
import OfferCard from "./OfferCard";
import { useMatomo } from '@datapunt/matomo-tracker-react'

const HomeComponent = () => {
  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView({ documentTitle: 'Home' })
  }, [])

  return (
    <div className="content padded">
      <img
        src="logo.png"
        alt="Gasthof Bären Logo"
        style={{
          width: "60%",
          maxWidth: "300px",
          marginBottom: "20px",
        }}
      />
      <p className="alex-brush" >Willkommen im Gasthof Bären</p>
      <p style={{
        fontSize: "17px",
        lineHeight: "1.8",
        maxWidth: "600px",
        margin: "20px auto",
        padding: "0 10px"
      }}>
        Hier kannst Du unkompliziert Tischreservierungen für unser Restaurant
        Gasthof Bären in Holzgau tätigen.
      </p>
      <p style={{
        fontSize: "17px",
        lineHeight: "1.8",
        maxWidth: "600px",
        margin: "20px auto",
        padding: "0 10px"
      }}>
        Wir bieten ein täglich wechselndes 5-Gänge Genussmenü mit verschiedenen Hauptspeisen zur Wahl. Dazu servieren wir edle Tropfen aus unserem hauseigenen Weinkeller.
      </p>
      <div style={{ margin: "30px 0" }}>
        <OfferCard />
      </div>
      <p style={{
        fontSize: "16px",
        lineHeight: "1.8",
        maxWidth: "600px",
        margin: "25px auto",
        padding: "15px",
        backgroundColor: "rgba(75, 148, 156, 0.08)",
        borderRadius: "12px",
        borderLeft: "4px solid #4b949c"
      }}>
        Unser Genussmenü kannst Du bis spätestens 12 Uhr am selben Tag online oder telefonisch reservieren.
      </p>
      <h4 style={{
        fontSize: "20px",
        marginTop: "35px"
      }}>Die Öffnungszeiten des Restaurants sind:</h4>
      <p style={{
        fontSize: "16px",
        lineHeight: "1.9",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        padding: "15px",
        borderRadius: "12px",
        maxWidth: "400px",
        margin: "15px auto",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
      }}>
        <strong>Montag bis Sonntag:</strong><br />
        8:00 Uhr - 23:00 Uhr
      </p>
      <p style={{
        fontSize: "16px",
        lineHeight: "1.9",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        padding: "15px",
        borderRadius: "12px",
        maxWidth: "400px",
        margin: "15px auto",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
      }}>
        <strong>Warme Küche:</strong><br />
        12:00 Uhr - 13:45 Uhr<br />
        18:00 Uhr - 20:15 Uhr
      </p>
      <p style={{
        fontSize: "17px",
        marginTop: "35px",
        marginBottom: "25px",
        fontStyle: "italic",
        color: "#324b4e"
      }}>
        Wir freuen uns auf Deinen Besuch!<br />
        Das Team vom Gasthof Bären
      </p>
    </div>
  );
};

export default HomeComponent;